import Computed from '../../../decorators/Computed';
import Observable from '../../../decorators/Observable';
import AbstractEntity from './AbstractEntity';
import IKeywordsEntity from './IKeywordsEntity';

export default class MainCategoryEntity
  extends AbstractEntity
  implements IKeywordsEntity
{
  public readonly type = 'MainCategoryEntity';

  @Observable()
  public data: {
    checked: boolean;
    id: number | string;
    displayName: string;
    name: string;
    keywords: string[];

    checkedKeywords?: string[];
    customAddedKeywords?: string[];

    areKeywordsProvided?: boolean;
  } = null;

  constructor(data: any) {
    super();

    this.data = data;
    this.data.checkedKeywords = this.data.checkedKeywords || [];
    this.data.customAddedKeywords = this.data.customAddedKeywords || [];

    this.initFields();
  }

  static fromJSON(json: any): MainCategoryEntity {
    if (json === null) {
      return null;
    }

    return new MainCategoryEntity(json.data);
  }

  @Computed()
  get name(): string {
    return this.data.name;
  }

  @Computed()
  get displayName(): string {
    return this.data.displayName;
  }

  @Computed()
  get id(): number | string {
    return this.data.id;
  }

  public getEntityType(): string {
    return this.type;
  }

  public getSessionKey(): string {
    return 'MainCategoryEntity' + this.data.id;
  }
}
